import { ComponentType } from 'react'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { AlertFilledIcon, InfoIcon, SuccessIcon, WarningFilledIcon } from 'transfix-icons'
import { TCarrierStatus } from './types'

export const carrierStatuses: Record<TCarrierStatus, string> = {
  activated: 'Active',
  new: 'Fresh',
  pending: 'Pending',
  application_submitted: 'App. Submitted',
  in_review: 'In Review',
  expired_insurance: 'Expired Ins.',
  out_of_service: 'Out of Service',
  conditional: 'Conditional',
  cancelled: 'Cancelled',
  other: 'Other',
  probation: 'Probation',
  do_not_use: 'Cannot Use',
  inactive: 'Inactive',
}

export const CARRIER_STATUS_ICON_MAP: Record<
  TCarrierStatus,
  { Icon: ComponentType<ICommonProps>; color: string }
> = {
  expired_insurance: { Icon: WarningFilledIcon, color: 'warning' },
  inactive: { Icon: AlertFilledIcon, color: 'error' },
  out_of_service: { Icon: AlertFilledIcon, color: 'error' },
  conditional: { Icon: AlertFilledIcon, color: 'error' },
  cancelled: { Icon: AlertFilledIcon, color: 'error' },
  do_not_use: { Icon: AlertFilledIcon, color: 'error' },
  probation: { Icon: AlertFilledIcon, color: 'error' },
  pending: { Icon: WarningFilledIcon, color: 'warning' },
  application_submitted: { Icon: WarningFilledIcon, color: 'warning' },
  in_review: { Icon: WarningFilledIcon, color: 'warning' },
  activated: { Icon: SuccessIcon, color: 'success' },
  new: { Icon: WarningFilledIcon, color: 'warning' },
  other: { Icon: InfoIcon, color: 'info' },
} as const

export type TCarrierStatusIcons = typeof CARRIER_STATUS_ICON_MAP
